<template>
  <div class="column-drag">
    <div class="column-drag__body">
      <!-- <div style="margin-bottom:8px">
        <el-checkbox v-model="localShowSelection">显示多选框</el-checkbox>
      </div> -->
      <draggable v-model="localColumns" handle=".drag-handle" :animation="200">
        <transition-group>
          <div
            v-for="(col, index) in localColumns"
            :key="index"
            class="drag-item drag-handle"
          >
            <i class="el-icon-rank drag-handle" title="拖拽排序"></i>
            <el-checkbox v-model="col.visible">{{ col.name }}</el-checkbox>
          </div>
        </transition-group>
      </draggable>
    </div>
    <div class="column-drag__footer">
      <el-button type="primary" @click="emitChange">应用</el-button>
    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable";
export default {
  name: "ColumnDrag",
  components: { draggable },
  props: {
    columns: { type: Array, default: () => [] },
    showSelection: { type: Boolean, default: true }
  },
  data() {
    return {
      localColumns: JSON.parse(JSON.stringify(this.columns)),
      localShowSelection: this.showSelection
    };
  },
  watch: {
    columns: {
      handler(n) {
        this.localColumns = JSON.parse(JSON.stringify(n));
      },
      deep: true
    },
    showSelection(n) {
      this.localShowSelection = n;
    }
  },
  methods: {
    emitChange() {
      this.$emit("update", {
        columns: this.localColumns,
        showSelection: this.localShowSelection
      });
    }
  }
};
</script>
<style scoped>
.column-drag {
  display: flex;
  flex-direction: column;
  max-height: 420px;
}
.column-drag__body {
  overflow-y: auto;
  padding: 6px 0;
}
.column-drag__footer {
  padding: 20px 0;
  text-align: right;
  border-top: 1px solid #eee;
  background: #fff;
}
.drag-item {
  display: flex;
  align-items: center;
  padding: 6px 8px;
  border-bottom: 1px dashed #eee;
}
.drag-handle {
  cursor: move;
  margin-right: 8px;
  color: #909399;
}
</style>
